import * as React from 'react';
import { MoneyField } from './money-field';

type Props = {
  id?: string;
  unitPriceTypeId: number | undefined;
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  onBlur?: () => void;
  error?: string;
};

export function UnitCostField({
  id = 'line-item-planned-unit-cost',
  unitPriceTypeId,
  value,
  onChange,
  onBlur,
  error
}: Props) {
  const isCPM = unitPriceTypeId === 1;
  return (
    <MoneyField
      id={id}
      label="Planned Unit Cost"
      suffix={isCPM ? 'CPM' : undefined}
      value={value}
      decimalScale={3}
      description="Defaults to Rate Card Target"
      placeholder="Auto-fills per Unit Price Type"
      disabled={unitPriceTypeId === undefined}
      onChange={onChange}
      onBlur={onBlur}
      error={error}
    />
  );
}
